import { defineCapability } from './internal';
import { args } from '../common/args';
export const REQUEST_ELEMENT_LOCATIONS_CAP = defineCapability({
  name: 'REQUEST_ELEMENT_LOCATIONS_CAP',
  args: {
    targetElements: args.arrayOf(args.object({
      targetElementSelector: args.string()
    }))
  }
});